import { ReviewCategoryType } from 'types/reviews';

export const CMI_DIGEST_WATCHLIST_TYPE = {
  NEEDS_ATTENTION: 'needs_attention',
  OTHER: 'other',
  INCENTIVES: 'incentives',
  REVIEWS: 'reviews',
  ANY: 'any',
} as const;

export type CmiDigestWatchlistType = (typeof CMI_DIGEST_WATCHLIST_TYPE)[keyof typeof CMI_DIGEST_WATCHLIST_TYPE];

export type CmiDigestWatchlistRun = {
  id: number;
  frequency_label: string;
  period_label: string;
};

export type CmiDigestWatchlistCommunityRun = {
  run_id: number;
  run_community_id: number;
  frequency_label: string;
  period_label: string;
};

export type CmiDigestWatchlistOverview = {
  overall_communities_summary_lines: string[];
  needs_attention_count: number;
  other_count: number;
  incentives_communities_count: number;
  reviews_communities_count: number;
};

export type CmiDigestWatchlistSupportingContextItem = {
  label: string;
  value: string;
  is_ai_generated: boolean;
};

export type CmiDigestWatchlistCommunityRow = {
  id: number;
  community_id: number;
  community_name: string;
  needs_attention: boolean;
  notable_items: string[];
  supporting_context: CmiDigestWatchlistSupportingContextItem[];
  summary: string[];
};

export type CmiDigestWatchlistReview = {
  id: number;
  from_name: string;
  from_source: string;
  rating: number | null;
  score: number | null;
  categories: ReviewCategoryType[];
  date: string;
  details: string;
};

export type CmiDigestWatchlistIncentive = {
  id: number;
  description: string;
  competitor_id: number;
  competitor_name: string;
  care_types: string[];
  date: string | null;
  created_at: string;
};

export type CmiDigestWatchlistRateComparisonRow = {
  community_id: number;
  community_name: string;
  is_own: boolean;
  rates: Record<string, number | null>;
};

export type CmiDigestWatchlistRateComparison = {
  care_type_id: number;
  care_type: string;
  room_types: string[];
  rows: CmiDigestWatchlistRateComparisonRow[];
};

export type CmiDigestWatchlistFeeComparisonRow = {
  community_id: number;
  community_name: string;
  is_own: boolean;
  community_fee: number | null;
  second_person_fee: number | null;
  pet_fee: number | null;
};

export type CmiDigestWatchlistFeeComparison = {
  care_type_id: number;
  care_type: string;
  rows: CmiDigestWatchlistFeeComparisonRow[];
};

export type CmiDigestWatchlistCommunityDetail = {
  id: number;
  community_id: number;
  community_name: string;
  needs_attention: boolean;
  notable_items: string[];
  summary: string[];
  supporting_context: CmiDigestWatchlistSupportingContextItem[];
  show_reviews: boolean;
  show_incentives: boolean;
  reviews: CmiDigestWatchlistReview[];
  incentives: CmiDigestWatchlistIncentive[];
  rate_comparison: CmiDigestWatchlistRateComparison[];
  fee_comparison: CmiDigestWatchlistFeeComparison[];
  community_runs: CmiDigestWatchlistCommunityRun[];
};
